/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Displayed when route does not exist.
 */
import React, { Component } from 'react';

class NoContent extends Component {
    render() {
        return (
            <div style={styles.container}>
                <h1>Acceso Denegado</h1>
                <img src="images/logo-title-dark.png" role="presentation" style={styles.img} />
                <h4>La página que usted está solicitando no existe o no cuenta con la autorización necesaria.</h4>
            </div>
        );
    }
}

const styles = {
    container: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    img: {
        marginTop: 50,
        marginBottom: 100
    }
};

export default NoContent;



// WEBPACK FOOTER //
// ./components/layout/noContent.js